import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AccountAddressBlockType} from "../../account-address-block-type";
import {AbstractSingleSelectEditControlComponent} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StatementAddressBlockTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-statement-address-block-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class StatementAddressBlockTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData([
            {label: "wbo.account-type.edit.option.contact", value: AccountAddressBlockType.CONTACT},
            {label: "wbo.account-type.edit.option.account", value: AccountAddressBlockType.ACCOUNT},
            {
                label: "wbo.account-type.edit.option.account_atn_contact",
                value: AccountAddressBlockType.ACCOUNT_ATTN_CONTACT
            },
            {
                label: "wbo.account-type.edit.option.account_name_and_no",
                value: AccountAddressBlockType.ACCOUNT_NAME_AND_NO
            }
        ]);
    }
}

